import { render, staticRenderFns } from "./CallNumGroupList.vue?vue&type=template&id=6badcf72&scoped=true&"
import script from "./CallNumGroupList.vue?vue&type=script&lang=js&"
export * from "./CallNumGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badcf72",
  null
  
)

export default component.exports